exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".demoVertical-grid .grid{min-height:300px;background:#f1f1f1;margin-bottom:calc(.89286vw + 17.14286px)}.demoVertical-grid .button{margin:0}", ""]);
